import type { PageRef, RouterData } from '@wix/editor-platform-sdk-types'
import type { EDITOR_TYPE } from '@wix/wix-data-client-common'
import { isEditor3 } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

export const getPageToNavigateAfterRemove = async ({
  editorSdkProxy,
  router: currentPageRouter,
  pageRef: currentPageRef,
  editorType,
}: {
  editorSdkProxy: EditorSDK
  router: RouterData
  pageRef: PageRef
  editorType: EDITOR_TYPE
}): Promise<PageRef | undefined> => {
  if (isEditor3(editorType)) {
    return undefined
  }

  const routerPages = currentPageRouter.pages.filter(
    routerPage => routerPage.pageRef.id !== currentPageRef.id,
  )
  if (routerPages.length) {
    return routerPages[0].pageRef
  }
  const routers = await editorSdkProxy.routers.getAll()
  const routersWithPages = routers
    .filter(router => router.id !== currentPageRouter.id)
    .filter(router => router.pages.length)

  if (routersWithPages.length) {
    return routersWithPages[0].pages[0].pageRef
  }
  return editorSdkProxy.pages.getHomePage()
}
